import React from 'react'


export const Bet365 = ({
  type = '',
  credit = '',
  situationNodeOdd = {},
  odds = {},
  defaultMsg = '',
  affiliateCodeOverwrite = ''
}) => {

  let oddsDetails = {}

  if( type === 'odds') {
    oddsDetails = odds
  } else {
    oddsDetails = situationNodeOdd
  }

  let oddsItems = oddsDetails.items || {}
  const keys = Object.keys(oddsItems)
  
  let markup = [ `<img src="http://a.espncdn.com/redesign/assets/img/logos/bet365.png" /> ${ oddsDetails.text ? oddsDetails.text : ''}` ]
  const keysLen = keys.length || 0

  if (keysLen > 0) {
    for(let i = 0; i < keysLen; i++) {
      const oddsItem = oddsItems[keys[i]] || {}
      if(affiliateCodeOverwrite) {
        oddsItem.href = updateAffiliateCode(oddsItem.href, affiliateCodeOverwrite)
        credit = updateAffiliateCode(credit, affiliateCodeOverwrite)
      }
      const nextBatsmen = keys[i] || ''
      const anchor = oddsItem.href ? `<a href=${oddsItem.href} target="_blank">${oddsItem.summary}</a>` : oddsItem.odds
      markup.push(`<span>${nextBatsmen} ${anchor}${keysLen-1 == i ? `. ${credit}` : ''}</span>`)
    }

    
  } else {
    if(affiliateCodeOverwrite) {
      credit = updateAffiliateCode(credit, affiliateCodeOverwrite)
    }
    markup.push(`<span>${defaultMsg}${credit}</span>`)
  }

  markup = markup.join('')
  
  return (
    <div dangerouslySetInnerHTML={{ __html : markup }}></div>
  )

}

const updateAffiliateCode = ((link, affiliateCodeOverwrite) => {
  let queryParam = link.indexOf('affiliatecode=') > -1 ? 'affiliatecode=' : 'affiliate='
  let regex = new RegExp('(' + queryParam + ').*?(&|\")')
  
  return link.replace(regex,'$1' + affiliateCodeOverwrite + '$2')
})

export default Bet365



/** WEBPACK FOOTER **
 ** ../app/components/common/Bet365.jsx
 **/